import { Component } from 'shimmer'

import { Vector3, MeshPhongMaterial } from 'three'

export default class SmartObject extends Component {
  constructor (loader) {
    super({name: 'Smart Object'})

    this.load = this.load.bind(this)
    this.clearChildren = this.clearChildren.bind(this)

    this.url = ''
    this._color = null
    this.object = null
    this.loader = loader
  }

  load (url, normalize = true) {
    this.clearChildren()
    this.url = url

    return new Promise(async (resolve) => {
      this.object = await this._loader(url, true)

      this.add(this.object)

      if (normalize) {
        this.normalizeSize()
      }

      if (this.color !== null) {
        this.colorItem()
      }

      resolve()
    })
  }

  clearChildren () {
    this.traverse(item => {
      if (item.isMesh) {
        item.material.dispose()
        item.geometry.dispose()
      }
    })
    for( let i = this.children.length - 1; i >= 0; i--) {
      this.remove(this.children[i])
    }
  }

  normalizeSize () {
    const targetHeight = 1
    this.object.scale.set(1, 1, 1)

    const size = this.size

    let ratio = targetHeight / size.y

    this.object.scale.set(ratio, ratio, ratio)
    this.positionItem()
  }

  positionItem () {
    this.object.position.set(0, 0, 0)
    const box = this.relativeBoundingBox
    const center = this.center

    this.object.position.sub(center)
  }

  colorItem () {
    if (this.item === null) return

    if (this.object) {
      if (this._color !== null) {
        this.object.traverse(item => {
          if (item.isMesh) {
            item.material.dispose()
            item.material = new MeshPhongMaterial({
              color: this._color
            })
            // this.treatObjects(item)
          }
        })
      }
      else {
        this.load(this.url)
      }
    }
  }

  set loader (loader) {
    this._loader = loader
  }

  set color (color) {
    this._color = color
    this.colorItem()
  }

  get color () {
    return this._color
  }
}
